import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const NAV_LINKS = [
  { key: 'about', href: '/#about' },
  { key: 'experience', href: '/#experience' },
  { key: 'skills', href: '/#skills' },
  { key: 'projects', href: '/#projects' },
  { key: 'contact', href: '/#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeAll = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <a href="/#hero" className="navbar__logo">EP</a>

      <button
        className={`navbar__hamburger${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Toggle navigation"
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={`navbar__links${menuOpen ? ' open' : ''}`}>
        {NAV_LINKS.map(({ key, href }) => (
          <li key={key}>
            <a href={href} onClick={closeAll}>{t(`nav.${key}`)}</a>
          </li>
        ))}
        <li className="navbar__lang-item">
          <LanguageSwitcher />
        </li>
      </ul>
    </nav>
  );
}
